import { Image, ImageProps } from '@chakra-ui/react';
import { GlobeIcon } from 'ui-components';

interface Props extends ImageProps {
  countryCode: string;
}

export const CircleFlagIcon: React.FC<Props> = ({ countryCode, ...props }) =>
  countryCode.toLowerCase() !== 'other' ? (
    <Image
      data-testid={`circle-flag-icon-${countryCode}`}
      src={`/images/flags/circle/${countryCode}.svg`}
      {...props}
    />
  ) : (
    <GlobeIcon viewBox="2 2 12 12" boxSize={6} />
  );
